module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp3_0.82d9ecb2.png";